module.exports = __webpack_public_path__ + "static/media/store_icon.e2d1a058.svg";